"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestProcessor = /** @class */ (function () {
    function RestProcessor() {
        this.headerProcessor = [];
        this.responseProcessor = [];
        this.jsonProcessor = [];
        this.fetchOptionProcessor = [];
    }
    RestProcessor.prototype.addHeaderProcessor = function (processor) {
        this.headerProcessor.push(processor);
    };
    RestProcessor.prototype.addResponseProcessor = function (processor) {
        this.responseProcessor.push(processor);
    };
    RestProcessor.prototype.addJsonProcessor = function (processor) {
        this.jsonProcessor.push(processor);
    };
    RestProcessor.prototype.addFetchOptionProcessor = function (processor) {
        this.fetchOptionProcessor.push(processor);
    };
    return RestProcessor;
}());
exports.default = RestProcessor;
